import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";

import EditTopBanner from "../../components/Forms/EditTopBanner";


class FormEditTopBanner extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Validation"
              Breadcrumb={[
                { name: "Form", navigate: "" },
                { name: "Validation", navigate: "" },
              ]}
            />
            <div className="row clearfix">
            
              <EditTopBanner/>
            </div>
            <div className="row clearfix">
              {/* <AdvancedValidation /> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ ioTReducer }) => ({});

export default connect(mapStateToProps, {})(FormEditTopBanner);
